// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// Import Mantine's core styles
import '@mantine/core/styles.css'; // Import core Mantine styles
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { MantineProvider } from '@mantine/core'; // Import MantineProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme="light"> {/* Or "dark" or "auto" */}
      <AuthProvider>
        <App />
      </AuthProvider>
    </MantineProvider>
  </React.StrictMode>
);

reportWebVitals();